import type { PatternFormFieldItem } from '@ricoh/ria.client.core/types/component/pattern.type';
import type { RecordKey } from '@ricoh/ria.client.core/types/core/data.type';

import type {
  PatternGenerateGuid,
  PatternGenerateNow,
  PatternGenerateNowType,
  PatternGenerateRandom,
  PatternGenerateType,
} from '~/common/model/api/batch-type/pattern';

import { TRANSFORMATION_TEXT } from '~/common/constants/feature/settings/batch-type-library';

const TIME_ZONE = undefined;

/** Create PatternGenerate. */
export const createPatternGenerate = {
  now: (type: PatternGenerateNowType, transformationText: boolean): PatternGenerateNow => ({
    $is: 'now',
    type,
    timeZone: TIME_ZONE,
    transformations: transformationText ? [TRANSFORMATION_TEXT] : undefined,
  }),

  guid: (): PatternGenerateGuid => ({
    $is: 'guid',
  }),

  random: (length?: number): PatternGenerateRandom => ({
    $is: 'random',
    length,
  }),
};

/** Create PatternGenerate FormField. */
export const createPatternGenerateFormField = {
  now: <TTabKey extends RecordKey>(tabKey: TTabKey, type: PatternGenerateNowType, transformationText: boolean): PatternFormFieldItem<TTabKey> => ({
    $is: 'tag',
    tabKey,
    value: type,
    settings: {
      timeZone: TIME_ZONE,
      transformations: transformationText ? [TRANSFORMATION_TEXT] : undefined,
    },
  }),

  default: <TTabKey extends RecordKey>(tabKey: TTabKey, type: PatternGenerateType): PatternFormFieldItem<TTabKey> => ({
    $is: 'tag',
    tabKey,
    value: type,
  }),
};
